export const getCategoryString = (category: string) => {
  try {
    return JSON.parse(category).join();
  } catch (e) {
    return "";
  }
};
